import { Component, OnDestroy, OnInit, inject, input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NgxEchartsDirective, provideEcharts } from 'ngx-echarts';
import { BaseComponent } from '../../../base/components/base.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  TodayAlertDetails,
  TodayAlertDetailsData,
} from '../../models/today-alert-details';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { SiService } from '../../../system-integrator/services/si.service';
@Component({
    selector: 'app-today-alerts',
    imports: [NgxEchartsDirective, TranslateModule, RouterModule],
    templateUrl: './today-alerts.component.html',
    styleUrl: './today-alerts.component.scss',
    providers: [provideEcharts()]
})
export class TodayAlertsComponent
  extends BaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  options!: EChartsOption;

  alertsDetails: TodayAlertDetailsData = {
    normalAlerts: 0,
    abnormalAlerts: 0,
    abnormalAlertsPlantCount: 0,
    normalAlertsPlantCount: 0,
  };

  todayAlertsSubscription!: Subscription;
  siService: SiService = inject(SiService);
  private readonly cdr = inject(ChangeDetectorRef);
  categoryId = input.required<string>();
  installer_id!: string;
  alertType: String = '';

  ngOnInit(): void {
    this.installer_id = this.authService.loggedUser.installer_id;

    this.getTodayAlerts();
    switch (this.categoryId()) {
      case '1':
        this.alertType = 'all';
        break;
      case '2':
        this.alertType = 'solar';
        break;
      case '3':
        this.alertType = 'non_solar';

        break;

      default:
        break;
    }
  }

  ngAfterViewInit(): void {
    if((globalThis as any).__karma__) return;
  }


  fillGraph() {
    this.options = {
      title: {
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
        renderMode: 'richText',
        confine: true,

      },
      series: [
        {
          type: 'pie',
          radius: '80%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          color: ['#CC5151', '#0051BA'],
          data: [
            {
              value: this.alertsDetails.abnormalAlerts,

              label: {
                backgroundColor: 'transparent',
                color: '#fff',
              },
            },
            {
              value: this.alertsDetails.normalAlerts,

              label: {
                backgroundColor: 'transparent',
                color: '#fff',
              },
            },
          ],
          labelLine: {
            show: false,
          },
          itemStyle: {
            borderColor: '#212932',
            borderWidth: 7,
          },

          emphasis: {
            itemStyle: {
              borderWidth: 0,
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(255, 255, 255, 0.2)',
            },
          },
        },
      ],
    };
  }

  getTodayAlerts() {
    this.todayAlertsSubscription = this.siService
      .getTodayAlertDetails(this.installer_id, this.categoryId())
      .subscribe({
        next: (value: TodayAlertDetails) => {
          if (value.data != null) {
            const data = value.data;
            setTimeout(() => {
              this.alertsDetails = data;
              this.fillGraph();
              this.cdr.detectChanges();
            });
          }
        },
        error: (e: Error) => {
          this.toastr.error(e.message);
        },
        complete: () => {
          this.baseUserService.todayAlertsLoading.next(true);
        },
      });
  }

  ngOnDestroy(): void {
    this.todayAlertsSubscription.unsubscribe();
  }
}
